var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLucentLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 400 420",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M191.675 8.338 27.547 104.72l47.011 28.832 117.117-67.549 117.942 67.549 46.187-28.832-164.129-96.38Z",
  fill: "#005F7F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.806 270.297v-120.27l99.797-56.84v116.975l-99.797 60.135Z",
  fill: "#2BB0C8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M203.222 210.162V93.186l98.147 56.841v120.27l-98.147-60.135Z",
  fill: "#97D8EA"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M203.222 410.338V351.85l117.117-65.901V150.027L369 122.018v192.763l-165.778 95.557Z",
  fill: "#005F7F"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 314.781V122.018l48.661 28.009v135.922l117.942 65.901v58.488L16 314.781Z",
  fill: "#97D8EA"
})));
export default SvgLucentLogo;